<template>
  <label class="radio">
    <input
      v-model="radioButtonValue"
      type="radio"
      :value="optionValue"
      :name="name"
      v-bind="$attrs"
    />
    <span class="label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    optionValue: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.model
      },
      set: function () {
        // Communicate the change to parent component so that selectedValue can be updated
        this.$emit('change', this.optionValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
// stylelint-disable
.radio {
  input[type='radio'] {
    --active: #007aff;
    --active-inner: #fff;
    --focus: 2px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #007aff;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;

    position: relative;
    display: inline-block;
    height: 17px;
    margin: 0;
    vertical-align: top;
    cursor: pointer;
    background: var(--b, var(--background));
    border: 1px solid var(--bc, var(--border));
    outline: none;
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
    }
    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }
    &:disabled {
      --b: var(--disabled);

      cursor: not-allowed;
      opacity: 0.9;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + .label {
        cursor: not-allowed;
      }
    }
    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }
    &:focus {
      box-shadow: 0 0 0 var(--focus);
    }
    &:not(.switch) {
      width: 17px;
      &::after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
    & + .label {
      margin-left: 4px;
      font-size: 14px;
      line-height: 17px;
      vertical-align: top;
      cursor: pointer;
    }
  }

  input[type='radio'] {
    border-radius: 50%;
    &::after {
      width: 15px;
      height: 15px;
      background: var(--active-inner);
      border-radius: 50%;
      opacity: 0;
      transform: scale(var(--s, 0.7));
    }
    &:checked {
      --s: 0.5;
    }
  }
}
</style>
